import moment from 'moment';
import { TaskUtility } from 'src/app/task/task.utility';
import { EventListService } from './grid-data-event.service';
export class TaskListUtils
{
    public static finalizeDataset(value: any, taskUtilityService: TaskUtility, eventListService: EventListService): void
    {
        if (value !== null)
        {
            const now = new Date();
            value.data.forEach(d =>
            {
                d.openedOn = new Date(d.openedOn);
                d.days = moment(now).diff(moment(d.openedOn), 'days');

                if (d.memberInfo !== null && d.memberInfo.dateOfBirth !== null && d.memberInfo.dateOfBirth !== undefined &&
                    d.memberInfo.dateOfBirth.length === 10)
                {
                    d.memberInfo.dateOfBirth = new Date(`${d.memberInfo.dateOfBirth}T12:00:00.000`);
                }

                if (d.dueDate !== null)
                {
                    d.dueDate = new Date(d.dueDate);

                    let d1 = moment(Date.UTC(d.dueDate.getFullYear(), d.dueDate.getMonth(), d.dueDate.getDate()));
                    let d2 = moment(Date.UTC(d.openedOn.getFullYear(), d.openedOn.getMonth(), d.openedOn.getDate()));
                    const diffDays = d1.diff(d2, 'days');

                    if (diffDays > 0)
                    {
                        d.targetDays = diffDays;
                        d1 = moment(Date.UTC(d.dueDate.getFullYear(), d.dueDate.getMonth(), d.dueDate.getDate()));
                        d2 = moment(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()));
                        d.daysLeft = d1.diff(d2, 'days');
                        d.goodDays = d.targetDays > 0 ? Array(Math.min(d.targetDays - 1, d.days)) : Array(0);
                        d.unusedDays = d.targetDays > 0 ? Array(Math.max(d.targetDays - 1 - d.days, 0)) : Array(0);
                        d.warnDayUsed = d.days >= d.targetDays;
                        d.overdueDays = d.targetDays > 0 ? Array(Math.max(d.days - d.targetDays, 0)) : Array(0);
                    }
                }
                else
                {
                    // When there are no dueDate, we are showing green dots from Task openedOn to now.
                    const d1 = moment(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()));
                    const d2 = moment(Date.UTC(d.openedOn.getFullYear(), d.openedOn.getMonth(), d.openedOn.getDate()));
                    d.targetDays = d1.diff(d2, 'days');
                    d.goodDays = d.targetDays > 0 ? Array(Math.min(d.targetDays, d.days)) : Array(0);
                }
                d.priorityBadgeClass = taskUtilityService.priorityBadgeClass(d.priority);
                d.priority = taskUtilityService.priority(d.priority);
                d.eventTypeIcon = eventListService.getEventTypeIcon(d.eventType);
                d.eventTypeText = eventListService.getEventTypeText(d.eventType);
                d.encounterTypeText = eventListService.getEncounterTypeText(d.encounterType);
                if (d.closedOn) { d.closedOn = new Date(d.closedOn); }
            }
            );
        }
    }
}
